import styled, { css } from 'styled-components';
import { Link } from 'react-router';

import { color, height, media, zIndex } from 'app/shared/styles_js/variables';

import { GridContainerSt } from '../Grid/Grid.css';

export const TopNavBarSt = styled.nav`
  position: fixed;
  z-index: ${zIndex.navbar + 10};
  top: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: ${height.topNavBar}px;
  background-color: ${color.brandSecondary};
`;

export const NavBarContainerSt = styled(GridContainerSt)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: ${height.topNavBar}px;
`;

export const TitleSt = styled(Link)`
  display: flex;
  flex: 0 1 80px;
  align-items: center;
  color: ${color.white};

  & > svg {
    height: 32px;
    width: 100px;
  }

  & > span {
    margin-left: 16px;
  }

  .logo-letter {
    fill: #fff;
  }

  .logo-line {
    fill: ${color.brandPrimary};
  }
`;

export const TitleAnchorSt = styled.a`
  display: flex;
  flex: 0 1 80px;
  align-items: center;
  color: ${color.white};

  & > svg {
    height: 32px;
    width: 100px;
  }

  & > span {
    margin-left: 16px;
  }

  .logo-letter {
    fill: #fff;
  }

  .logo-line {
    fill: ${color.brandPrimary};
  }
`;

export const NavigationSt = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
`;

export const NavItemTextSt = styled.span`
  display: none;
  color: ${color.white};

  ${media.lg(css`
    display: block;
    margin-left: 16px;
  `)};
`;

export const NavItemSt = styled(Link)`
  display: flex;
  align-items: center;
`;

export const NavItemAnchorSt = styled.a`
  display: flex;
  align-items: center;
`;
